var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC2SwingGateClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 24v5.8c-7.34-3.23-18.36-4.92-29-4.92S16.33 26.56 9 29.8V24H3v33h70V24h-6zM36 53H9V34.23c5.18-2.74 14.54-5.11 27-5.34V53zm31 0H40V28.89c12.46.23 21.82 2.6 27 5.34V53zM43 42v-3a2 2 0 014 0v3a2 2 0 01-4 0zm-14 0v-3a2 2 0 014 0v3a2 2 0 01-4 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C2_Swing_gate_close.a7f92c65.svg";
export { SvgC2SwingGateClose as ReactComponent };